'use strict';

var helper = require('../helper');

module.exports = {

    pushProductChangeImageInteraction (sku) {
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '34',
            'eventname': 'product',
            'action': 'image_swipe',
            'product_id': sku
        };

        helper.log('Pushing product change color interaction!', true);
        helper.push(pushObject);
    },

    pushProductChangeColorInteraction (data) {
        var pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '35',
            'eventname': 'product',
            'action': 'change_color',
            'product_id': data.sku,
            'text': data.color,
            'type': data.promotionType
        };

        helper.log('Pushing product change color interaction!', true);
        helper.push(pushObject);
    },

    getFormattedSkuForAnalytics (sku, size) {
        let splitSku = sku.split('_');
        let selectedPid = splitSku[0];
        let selectedColor = splitSku[1];
        let formattedSku = selectedPid + '_' + selectedColor + '_' + size;
        return formattedSku;
    },

    pushProductChangeSizeInteraction (data) {
        let sku = this.getFormattedSkuForAnalytics(data.sku, data.size);
        var pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '36',
            'eventname': 'product',
            'action': 'change_size',
            'product_id': sku,
            'text': data.size,
            'type': data.promotionType
        };

        helper.log('Pushing product change size interaction!', true);
        helper.push(pushObject);
    },

    pushProductZoomInteraction (sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '37',
            'eventname': 'product',
            'action': 'zoom',
            'product_id': sku
        };

        helper.log('Pushing product zoom interaction!', true);
        helper.push(pushObject);
    },

    pushProductStyleAndGuidesClickInteraction (sku) {
        sku = helper.getFormatSku(sku);
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '160',
            'eventname': 'size_suggestion',
            'action': 'click_cta_find_your_size',
            'product_id': sku
        };

        helper.log('Pushing product click on style and guides interaction!', true);
        helper.push(pushObject);
    },

    pushProductInformationalMenuChange (action, info, sku) {
        if (!action || !info || !sku) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '38',
            'eventname': 'product',
            'action': action,
            'type': info,
            'product_id': sku,
        };

        helper.log('Pushing product detail page information interaction ' + info + '!', true);
        helper.push(pushObject);
    },

    pushRatingAndReviewsInteraction101 (action, word, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '101',
            'eventname': 'product_rating_and_reviews',
            'action': action,
            'text': word,
            'product_id': sku
        };

        helper.log('Pushing rating and reviews interaction - pdp - filter or sort products', true);
        helper.push(pushObject);
    },

    pushRatingAndReviewsInteraction102 (productName, sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '102',
            'eventname': 'product_rating_and_reviews',
            'action': 'review_guidelines',
            'product_id': sku
        };

        helper.log('Pushing rating and reviews interaction - form - guidelines', true);
        helper.push(pushObject);
    },

    pushRatingAndReviewsInteraction103 (overallRating, sizeRating, qualityRating, comfortabilityRating, sku) {
        if (overallRating === 1) {
            overallRating = '1_star';
        } else if (overallRating === 2) {
            overallRating = '2_stars';
        } else if (overallRating === 3) {
            overallRating = '3_stars';
        } else if (overallRating === 4) {
            overallRating = '4_stars';
        } else if (overallRating === 5) {
            overallRating = '5_stars';
        }
        if (!sizeRating) {
            sizeRating = 'feedback_not_provided';
        }
        if (!qualityRating) {
            qualityRating = 'feedback_not_provided';
        }
        if (!comfortabilityRating) {
            comfortabilityRating = 'feedback_not_provided';
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '103',
            'eventname': 'product_reviewed',
            'action': 'submit_the_form',
            'label': overallRating,
            'size_rating': sizeRating,
            'quality_rating': qualityRating,
            'comfortability_rating': comfortabilityRating,
            'product_id': sku
        };

        helper.log('Pushing rating and reviews interaction - form - guidelines', true);
        helper.push(pushObject);
    },

    pushRatingAndReviewsInteraction104 (action) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '104',
            'eventname': 'product_rating_and_reviews',
            'action': action
        };

        helper.log('Pushing rating and reviews interaction - review sent', true);
        helper.push(pushObject);
    },

    pushReviewsButtonOnPdpInteraction (category, sku) {
        if (!category || !sku) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '136',
            'eventname': 'product_rating_and_reviews',
            'action': 'see_the_reviews',
            'category': category,
            'product_id': sku
        };

        helper.log('Pushing see the reviews button interaction in pdp!', true);
        helper.push(pushObject);
    },

    pushLikeDislikeToReview (action, stars, sku) {
        if (!action || !stars || !sku) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '137',
            'eventname': 'product_rating_and_reviews',
            'action': action,
            'category': stars,
            'product_id': sku
        };

        helper.log('Pushing like or dislike button to a review interaction!', true);
        helper.push(pushObject);
    },
    pushProductDetailPageGuideInteraction (action, sku) {
        if (!action || !sku) {
            return;
        }

        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '141',
            'eventname': 'product',
            'action': 'size_guide',
            'type': action,
            'product_id': sku
        };

        helper.log('Pushing product detail page guide interaction!', true);
        helper.push(pushObject);
    },

    pushCompleteThePromoInteraction (name, location) {
        if (!name || !location) {
            return;
        }
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '142',
            'eventname': 'complete_promo',
            'label': name,
            'position': location
        };

        helper.log('Pushing complete the promo click interaction ' + name + ' !', true);
        helper.push(pushObject);
    },
    pushFindOutMoreTraceabilityInteraction () {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '148',
            'eventname': 'traceability_more_info'
        };

        helper.log('Pushing find out more traceability interaction!', true);
        helper.push(pushObject);
    },

    // 7.151 PRODUCT DETAIL PAGE – SEARCH NEAREST STORE
    pushSearchNearestStorePDP (sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '159',
            'eventname': 'product',
            'action': 'pick_up_store',
            'type': 'search_nearest_store',
            'product_id': sku
        };

        helper.log('Pushing search nearest store interaction from pdp!', true);
        helper.push(pushObject);
    },
 
    pushCTASizeSuggestion (sku) {
        let pushObject = {
            'event': 'GAevent',
            'ss_event_id': Date.now().toString().concat(Math.random().toString(36).substring(1, 13)),
            'eventID': '159',
            'eventname': 'product',
            'action': 'virtual_dressing_room',
            'product_id': sku
        };
 
        helper.log('Pushing virtual dressing room interaction', true);
        helper.push(pushObject);
    }
};
